if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this;

      // Aspetta che il DOM delle slide sia pienamente pronto
      requestAnimationFrame(() => {
        let dots = slideshow.dataset.dots === 'true',
            autoplay = slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
            align = slideshow.dataset.align == 'center' ? 'center' : 'left',
            fade = slideshow.dataset.fade == 'true',
            prev_button = slideshow.querySelector('.flickity-prev'),
            next_button = slideshow.querySelector('.flickity-next'),
            rightToLeft = document.dir === 'rtl',
            args = {
              wrapAround: true,
              cellAlign: align,
              pageDots: dots,
              contain: true,
              fade: fade,
              autoPlay: autoplay,
              rightToLeft: rightToLeft,
              prevNextButtons: false,
              cellSelector: '.carousel__slide',
              adaptiveHeight: true
            };

        // Inizializza solo se ci sono davvero slide nel DOM
        const slideCount = slideshow.querySelectorAll('.carousel__slide').length;
        if (slideCount > 0) {
          const flkty = new Flickity(slideshow, args);
          slideshow.dataset.initiated = true;

          if (prev_button && next_button) {
            prev_button.addEventListener('click', () => flkty.previous());
            prev_button.addEventListener('keyup', () => flkty.previous());
            next_button.addEventListener('click', () => flkty.next());
            next_button.addEventListener('keyup', () => flkty.next());
          }

          // Forza visibilità dei testi
          slideshow.querySelectorAll('.slideshow__slide-content').forEach(content => {
            content.style.opacity = '1';
            content.style.visibility = 'visible';
          });
        } else {
          console.warn('SlideShow non inizializzato: nessuna slide trovata');
        }
      });
    }
  }

  customElements.define('slide-show', SlideShow);
}

